import { useState, useEffect } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import NewsletterPopup from '../NewsletterPopup';

const ShopLayout = ({ children }) => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if user has already dismissed the popup
    const hasSeenPopup = sessionStorage.getItem('newsletter_popup_seen');
    
    if (!hasSeenPopup) {
      // Show popup after 5 seconds
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
    sessionStorage.setItem('newsletter_popup_seen', 'true');
  };

  return (
    <div className="min-h-screen flex flex-col" data-testid="shop-layout">
      <Navigation />
      
      {/* Main content with padding for fixed header */}
      <main className="flex-1 pt-[88px] md:pt-[104px]">
        {children}
      </main>
      
      <Footer />
      
      {/* Newsletter Popup */}
      {showPopup && <NewsletterPopup onClose={handleClosePopup} />}
    </div>
  );
};

export default ShopLayout;
